module.exports = __webpack_public_path__ + "img/icn_hot_active.2f358c32.svg";